function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2344 45C23.9527 45 26.1562 42.7964 26.1562 40.0781C26.1562 37.3598 23.9527 35.1562 21.2344 35.1562C18.5161 35.1562 16.3125 37.3598 16.3125 40.0781C16.3125 42.7964 18.5161 45 21.2344 45Z",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M46.9375 40.625H26.1562",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1758 40.625H3.5293C2.85849 40.625 2.21515 40.3561 1.74081 39.8775C1.26648 39.3989 1 38.7498 1 38.0729V15.1042C1 13.7505 1.53296 12.4522 2.48163 11.495C3.4303 10.5378 4.71697 10 6.05859 10H31.3516L41.4688 20.2083V40.625",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2344 16.5625H10.2969C8.78672 16.5625 7.5625 17.7867 7.5625 19.2969V24.7656C7.5625 26.2758 8.78672 27.5 10.2969 27.5H21.2344C22.7445 27.5 23.9688 26.2758 23.9688 24.7656V19.2969C23.9688 17.7867 22.7445 16.5625 21.2344 16.5625Z",
  stroke: "#FFD200",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCaravan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaravan);
export default __webpack_public_path__ + "static/media/caravan.aca5f335.svg";
export { ForwardRef as ReactComponent };